import type BaseModel from "../models/BaseModel";
import { showToast } from "./Toasts";
import { furnitureResolvers } from "../../ConceptOne/src/furniture/C1_furnitureResolvers";

/** Common feedback for rejected delete attempts; eligibility checks remain silent. */
export function showDeletionPreventedToast(object: BaseModel, mode: string): void {
  const modes: Record<string, string> = {
    building: state.translate("c1.ui.Gebaude", "Gebäude"),
    furnishing: state.translate("stepsHeader.defaultFunctions", "Ausstattung"),
    EloConcept: state.translate("c1.ui.Elektro", "Elektro"),
    EloDetail: state.translate("c1.ui.Elektro", "Elektro"),
    interactionConcept: state.translate("c1.ui.Bedienung", "Bedienung"),
  };
  const furnitureId = object.c1?.className === "C1_Furniture" ? object.c1.data?.definitionId : undefined;
  const furnitureName = furnitureId ? furnitureResolvers.displayName?.(furnitureId) : undefined;
  const objectName = object.name || furnitureName || (object.className === "C1_Wall" ? state.translate("c1.ui.Wand", "Wand") : object.className);
  const name = [object.fullTag, objectName].filter(Boolean).join(" ");
  void showToast({
    text: state
      .translate("menubarActions.deletionPreventedInMode", "Löschen von {xx} im Mode {yy} wurde verhindert.")
      .replace("{xx}", name) // no itx
      .replace("{yy}", modes[mode] ?? mode), // no itx
  });
}
